import { Toaster as Sonner } from "sonner"

const Toaster = ({
  ...props
}) => {
  // CRA app, no theme switching — hardcode light. (shadcn's stock template
  // imports from `next-themes` which is a Next.js-only dep.)
  return (
    <Sonner
      theme="light"
      position="top-center"
      className="toaster group"
      toastOptions={{
        classNames: {
          // No `richColors` — success/error show as the app's white card with
          // a coloured status icon, matching the rest of the UI's surfaces.
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          success: "[&_[data-icon]]:text-brand-success",
          error: "[&_[data-icon]]:text-brand-destructive",
          description: "group-[.toast]:text-muted-foreground",
          // The `!` flags are load-bearing: sonner styles its buttons with
          // [data-sonner-toast][data-styled='true'] [data-button] — specificity
          // (0,3,0), the SAME as our compiled .group.toast .group-[...] rules.
          // A tie is broken by stylesheet order, which differs between the dev
          // server and the production bundle (black button on prod, blue on
          // dev). !important makes ours win everywhere.
          actionButton:
            "group-[.toast]:!bg-primary group-[.toast]:!text-primary-foreground group-[.toast]:!rounded-token-large",
          cancelButton:
            "group-[.toast]:!bg-muted group-[.toast]:!text-muted-foreground group-[.toast]:!rounded-token-large",
        },
      }}
      {...props} />
  );
}

export { Toaster }
